export default __webpack_public_path__ + "static/media/all-temples-pengaciprolu-card-img.f9406184.png";